/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FSidebar%2FSidebarExpandButton%2FSidebarExpandButton.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    Развернуть: {
        ru: 'Развернуть',
        en: 'Expand',
        tr: 'Genişlet',
        'zh-Hans': '展开',
    },
    Свернуть: {
        ru: 'Свернуть',
        en: 'Collapse',
        tr: 'Daralt',
        'zh-Hans': '折叠',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
